import type * as type from "@vTypes";
import { useState } from "react";
import LoadingSpiner from "@/components/ui/LoadingSpiner";
import Customer_historyTable_tr from "./Customer_historyTable_tr";
import Customer_write from "./Customer_write";
import CustomModal from "@/components/modal/CustomModal";
import { cn } from "@/utils/cn";
import type { ContactItem } from "@/hooks/useContactList";

export default function Customer_history({
  myQuestionList,
  writeQuestion,
  isPending = false,
}: {
  myQuestionList: ContactItem[];
  writeQuestion: (payload: type.QuestionPayload) => void;
  isPending?: boolean;
}) {
  const [opendIndex, setOpendIndex] = useState<number | null>(null);
  const [isInquiryModalOpen, setIsInquiryModalOpen] = useState(false);

  function opendTr(idx: number) {
    if (opendIndex === null || opendIndex !== idx) {
      setOpendIndex(idx);
    } else {
      setOpendIndex(null);
    }
  }

  // 정렬된 목록
  const sortedQuestionList = [...myQuestionList].sort(
    (a, b) => (b.No ?? 0) - (a.No ?? 0)
  );

  return (
    <div className="mx-auto w-fit pt-10 min-h-[500px]">
      <div className="flex justify-between items-center mb-5">
        <div className="text-2xl font-semibold">나의 문의 내역</div>
        <button
          className="border py-3 border-zinc-300 min-w-[150px] rounded-full hover:border-zinc-400"
          onClick={() => setIsInquiryModalOpen(true)}
        >
          문의하기
        </button>
      </div>

      <div className="cs_history_grid cs_historyTable_thead">
        <div className="cs_historyTable_cell">번호</div>
        <div className="cs_historyTable_cell">제목</div>
        <div className="cs_historyTable_cell">작성일</div>
        <div className="cs_historyTable_cell">답변여부</div>
        <div className="cs_historyTable_cell"></div>
      </div>

      {isPending ? (
        <div className="flex flex-col items-center justify-center min-h-[280px] py-12">
          <LoadingSpiner msg="문의 내역을 불러오는 중입니다" />
        </div>
      ) : sortedQuestionList.length ? (
        sortedQuestionList.map((item, index) => {
          const opend = opendIndex === index;
          return (
            <Customer_historyTable_tr
              key={index}
              qnaNo={sortedQuestionList.length - index}
              opend={opend}
              data={item}
              clickEvent={() => {
                opendTr(index);
              }}
            />
          );
        })
      ) : (
        <div className="cs_historyTable_cell ta-c c-999 mt-10">
          문의내역이 없습니다.
        </div>
      )}

      {isInquiryModalOpen ? (
        <CustomModal.Panel
          onClose={() => setIsInquiryModalOpen(false)}
          dismissOnOverlay
          className={cn()}
        >
          <div className="p-4">
            <Customer_write
              writeQuestion={(payload) => {
                writeQuestion(payload);
                setIsInquiryModalOpen(false);
              }}
              onCancel={() => setIsInquiryModalOpen(false)}
            />
          </div>
        </CustomModal.Panel>
      ) : null}
    </div>
  );
}
